<template>
  <div class="edit-notice">
    <v-card class="rounded-lg pb-4">
      <v-form id="edit-news" @submit.prevent="updateNews">
      <v-row class="px-4 ma-0">
        <v-col cols="12">
          <v-card-title class="text-center text-h4 font-weight-bold px-0" style="color: #62608b">Edit Notice</v-card-title>
        </v-col>
        
        <v-col cols="12">
          <div v-if="!$v.informationData.title.required && $v.informationData.title.$dirty" class="validation-text red--text text-body-2 error-span">Title required.</div>
          <div v-if="!$v.informationData.title.maxLength" class="validation-text red--text text-body-2">Title should be {{$v.informationData.title.$params.maxLength.max}} characters long.</div>
          <v-text-field class="rounded" label="Title*" autofocus :value="$v.informationData.title.$model" @input="setNoticeProperty({property: 'title', value: $event})" outlined dense></v-text-field>

          <div v-if="!$v.informationData.description.required && $v.informationData.description.$dirty" class="validation-text red--text text-body-2 error-span">Description required.</div>
          <div v-if="!$v.informationData.description.maxLength" class="validation-text red--text text-body-2">Description should be {{$v.informationData.description.$params.maxLength.max}} characters long.</div>
          <v-textarea class="rounded" :value="$v.informationData.description.$model" @input="setNoticeProperty({property: 'description', value: $event})" label="Description*" outlined></v-textarea>
        </v-col>
        <!-- <v-col cols="12" class="my-0 py-0">
          <v-file-input
            id="select-image"
            accept="image/*"
            label="Images"
            v-show="false"
            v-model="media_file"
            @change="onAddImages"
          ></v-file-input>
          <v-img max-height="370" max-width="595" v-if="informationData.media_file" :src="imageUrl !== '' ?imageUrl:informationData.media_file" @click="selectImage"></v-img>
          <v-card class="select-image-card" elevation="0" v-else width="595" height="370">
            <v-row class="select-image" align="center" no-gutters>
              <v-col cols="3" class="justify-center mx-auto">
                <v-btn text large @click="selectImage">
                  <v-icon color="#D4C6BA" size="80">mdi-cloud-upload</v-icon>
                </v-btn>
                <v-card-text class="my-0">Upload here</v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col> -->
        <v-col cols="12">
          <v-card-actions class="mx-0 px-0">
            <v-btn class="white--text text-uppercase rounded btn-width"  color="action_btn_color" :disabled="overlay" type="submit" for="edit-news">Update</v-btn>
            <v-btn class="white--text text-uppercase rounded btn-width" color="error" :disabled="overlay" @click="$emit('cancel-edit')">Cancel</v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
      </v-form>
    </v-card>
    <!-- <v-dialog v-model="postComplete" width="500" persistent>
      <v-card>
        <v-card-title class="headline green lighten-2">
          News updated successfully
        </v-card-title>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="finishedPost"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <v-dialog v-model="postComplete" width="500" persistent>
      <v-card justify="center" align="center" class="rounded-lg" style="padding-top:40px;padding-bottom:40px">
        <v-card-text class="d-flex justify-center align-center px-0 py-0"
          style="border-radius:50%; border:4px solid #f1f7ec;width:120px;height:120px;margin-bottom:25px">
          <v-icon color="#abd193" style="font-size:80px">
            mdi-check
          </v-icon>
        </v-card-text>
        <v-card-text>
          <span class="text-h4 font-weight-bold">Notice updated successfully</span><br>
          <v-btn large depressed class="white--text rounded" color="#8bd4f5" style="margin-top:25px"
            @click="finishedPost">
            OK
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  data: () => ({
    imageUrl: '',
    errorImage: '',
    postComplete: false,
    overlay: false,
    media_file: undefined
  }),
  computed: {
    ...mapGetters('event', {
      informationData: 'getNotice'
    })
  },
  validations() {
    return {
      informationData: {
        title: {
          required,
          maxLength: maxLength(100)
        },
        description: {
          required,
          maxLength: maxLength(20000)
        }
      }
    }
  },
  watch: {
      postComplete() {
        if (this.postComplete) {
          setTimeout(() => {
            this.postComplete = false
            // this.$router.push({
            //   path: '/'
            // })
          }, 3000)
        }
      },
    },
  methods: {
    ...mapActions('event', [
      'updateNotice'
    ]),
    ...mapMutations('event', [
      'setNoticeProperty'
    ]),
    selectImage() {
      document.getElementById("select-image").click()
    },
    onAddImages(file) {
      this.setNoticeProperty({property: 'media_file', value: file})
      const reader = new FileReader()
      reader.addEventListener('load', e => this.imageUrl = e.target.result)
      reader.addEventListener('error', () => this.imageUrl = this.errorImage)
      reader.readAsDataURL(file)
    },
    updateNews() {
      this.overlay = true
      this.$v.$touch()
      if(!this.$v.$invalid) {
        this.updateNotice().then(() => {
          this.postComplete = true
          this.overlay = false
        }).catch(() => {
          this.overlay = false
        })
      } else {
        this.overlay = false
      }
    },
    finishedPost() {
      this.postComplete = false
    },
  }
}
</script>
<style scoped>
.select-image-card {
  background: #F7F7F7;
  border: 1px dashed #423D3D;
}
.select-image {
  height: inherit;
}
.input-text-section {
  height: 370px;
  display: grid;
  align-self: center;
}
.validation-text {
  position: relative;
  bottom: 20px;
}

  .error-span {
    margin-bottom: -18px !important;
  }

</style>
